var _circle, _circle2, _path, _path2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShreder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 99,
    r: 60,
    transform: "rotate(-180 99 99)",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.9999,
    cy: 99,
    r: 79,
    transform: "rotate(15 98.9999 99)",
    stroke: "#F1F1F1",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.364 79.6367H81.9999C81.1965 79.6367 80.5454 80.288 80.5454 81.0912C80.5454 81.8946 81.1967 82.5457 81.9999 82.5457H102.364C103.167 82.5457 103.818 81.8945 103.818 81.0912C103.818 80.288 103.167 79.6367 102.364 79.6367Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.182 88.3636H127.091C128.697 88.3636 130 89.6661 130 91.2726V102.909C130 104.516 128.697 105.818 127.09 105.818H124.181V124.727C124.181 125.53 123.53 126.182 122.727 126.182C121.924 126.182 121.272 125.531 121.272 124.727V105.818H118.363V127.636C118.363 128.439 117.712 129.091 116.909 129.091C116.105 129.091 115.454 128.44 115.454 127.636V105.818H112.545V118.909C112.545 119.712 111.894 120.363 111.09 120.363C110.287 120.363 109.636 119.712 109.636 118.909V105.818H106.727V116C106.727 116.803 106.076 117.454 105.272 117.454C104.469 117.454 103.818 116.803 103.818 116V105.818H99.4543V124.727C99.4543 125.53 98.803 126.182 97.9998 126.182C97.1965 126.182 96.5452 125.531 96.5452 124.727V105.818H92.1816V127.636C92.1816 128.439 91.5304 129.091 90.7271 129.091C89.9239 129.091 89.2726 128.44 89.2726 127.636V105.818H86.3635V113.091C86.3635 113.894 85.7124 114.545 84.909 114.545C84.1058 114.545 83.4545 113.894 83.4545 113.091V105.818H80.5454V121.818C80.5454 122.621 79.8942 123.273 79.0909 123.273C78.2876 123.273 77.6364 122.622 77.6364 121.818V105.818H74.7273V130.546C74.7273 131.349 74.076 132 73.2727 132C72.4695 132 71.8183 131.349 71.8183 130.546V105.818H68.9091C67.3025 105.818 66 104.516 66 102.909V91.2728C66 89.6661 67.3025 88.3636 68.9091 88.3636H71.8181V70.9091C71.8181 69.3025 73.1206 68 74.7273 68H112.546L124.182 79.6364V88.3636ZM119.818 79.6364L112.546 72.3636V79.6364H119.818ZM74.7273 70.9091H109.636V81.091C109.636 81.8944 110.288 82.5455 111.091 82.5455H121.273V88.3636H74.7273V70.9091ZM68.9091 102.909H127.091H127.091V91.2728H68.9091V102.909Z",
    fill: "#4A4A4A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.091,
    cy: 97.0912,
    r: 1.4545,
    fill: "#9B9B9B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2729,
    cy: 97.0912,
    r: 1.4545,
    fill: "#9B9B9B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShreder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shreder.e7df94ff74abda300cffc7c696a2d280.svg";